import { useCustomerStatementsDates } from '@egw/api'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { useMemo, type FC } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { getLatest3StatementDates } from '../../utils'
import { ListLink } from '../list-link/list-link'

export const Statements: FC = () => {
  const { t } = useTranslation('features-documents')
  const { data, isLoading } = useCustomerStatementsDates()

  const latest3StatementDates = useMemo(() => {
    return getLatest3StatementDates(data)
  }, [data])

  return (
    <>
      <h2 className="mb-4 text-2xl font-semibold">{t('statements.title')}</h2>

      {isLoading ? (
        <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
          <Skeleton count={1} height="50px" />
        </SkeletonTheme>
      ) : null}

      {!isLoading && latest3StatementDates ? (
        <>
          {latest3StatementDates.length ? (
            <>
              {latest3StatementDates.map((item) => (
                <ListLink key={item.name} to={item.url} title={item.name} />
              ))}
              <ListLink to={WEALTH_ROUTES.DOCUMENTS_STATEMENTS.path} title={t('statements.all_statements')} />
            </>
          ) : (
            <div className="bg-bglight text-body px-3 py-3.5">{t('statements.no_statements')}</div>
          )}
        </>
      ) : null}
    </>
  )
}
